import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AzureCosmosV2CopySource } from 'app/model/pipeline/copysource/azure-cosmos.v2.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureCosmosV2CopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        pageSize: '*',
        detectDatetime: '*',
        preferredRegions: '*'
    }
})
export class AzureCosmosV2CopySourceAdapter extends CopySourceAdapter<
    AzureCosmosV2CopySource,
    Model.CosmosDbSqlApiSource
> {
    protected override async _toResource(copySource: AzureCosmosV2CopySource): Promise<Model.CosmosDbSqlApiSource> {
        const result: Model.CosmosDbSqlApiSource = this.getCommonCopySourceProperties(
            copySource,
            AzureCosmosV2CopySource.MODEL.name
        );
        if (copySource.mode === 'query') {
            result.query = ValueAdapter.toResource(copySource, AzureCosmosV2CopySource.READER_QUERY);
        }
        result.preferredRegions = ValueAdapter.toResource(copySource, AzureCosmosV2CopySource.PREFERRED_REGIONS);
        result.pageSize = ValueAdapter.toResource(copySource, AzureCosmosV2CopySource.PAGE_SIZE);
        result.detectDatetime = ValueAdapter.toResource(copySource, AzureCosmosV2CopySource.DETECT_DATE_TIME);
        // result.includeSystemColumns = ValueAdapter.toResource(copySource, AzureCosmosV2CopySource.INCLUDE_SYSTEMCOLUMNS);
        return result;
    }

    protected override async _toModel(
        resource: Model.CosmosDbSqlApiSource,
        copyActivity: CopyActivity
    ): Promise<AzureCosmosV2CopySource> {
        const result = this.createCopySourceWithCommonProperties(
            AzureCosmosV2CopySource.MODEL,
            resource,
            copyActivity
        ) as AzureCosmosV2CopySource;
        if (resource.query) {
            ValueAdapter.toModel(result, AzureCosmosV2CopySource.READER_QUERY, resource.query);
            result.mode = 'query';
        }
        ValueAdapter.toModel(result, AzureCosmosV2CopySource.PREFERRED_REGIONS, resource.preferredRegions);
        ValueAdapter.toModel(result, AzureCosmosV2CopySource.PAGE_SIZE, resource.pageSize);
        ValueAdapter.toModel(result, AzureCosmosV2CopySource.DETECT_DATE_TIME, resource.detectDatetime);
        // ValueAdapter.toModel(result, AzureCosmosV2CopySource.INCLUDE_SYSTEMCOLUMNS, resource.includeSystemColumns);
        return result;
    }
}
